/*
 * controllers/golfController.js
 * Golf Controller
 */

define('app/controllers/golfController',[
    'app/ControllerClass',
    'app/models/golfModel',
    'app/views/golfView',
    'moment', 'underscore'], function( ControllerClass, GolfModel, GolfView, moment, _) {
    return window.app.controllers.golfController = $.extend({}, ControllerClass, {
        app:app,
        module: 'golf',

        actions:{
            'show':['golfBookingSelected'],
            'location':['golfLocationSelected'],
            'course':['golfCourseSelected'],
            'teetime':['golfTeeTimeSelected'],
            'showGolferModal':['showGolferInfoModal'],
            'confirm':['golfRates'],
            'book':['golfBook'],
            'partialPayment':['golfPartialPayment']

        },
        init:function () {
            console.log('initializing golf controller');
            app.data.messages = app.data.messages || [];
            this._init.call(this);
        },

        golfBookingSelected:function (stop) {
            var self = this;
            $.when(app.models.golfModel.getData('golfLocations', {}))
                .done(function (r_gl) {
                    if (r_gl.GolfLocation != undefined) {
                        var membershipIds = app.data.membershipDetails && app.data.membershipDetails.membershipItemIds || [];
                        var vipLevels = app.data.membershipDetails && app.data.membershipDetails.VIPLevels || [];
                        // Dynamic restriction tryingToBook_module
                        app.commonViewHelper.eval_ttb({module:"golfBooking", vipLevel: vipLevels, membershipId:membershipIds});
                        var golfLocations = r_gl.GolfLocation;
                        // Dynamic restriction code for enable Golf Locations
                        if(app.customization.dynamicRestrictions && app.commonViewHelper.activeEffects.enableGolfLocations){
                            var enableGolfLocationsResult = app.commonViewHelper.groupEffects(app.commonViewHelper.activeEffects.enableGolfLocations);
                            if(enableGolfLocationsResult.isActive && enableGolfLocationsResult.value && enableGolfLocationsResult.value.length){
                                if(typeof enableGolfLocationsResult.value == 'object' && enableGolfLocationsResult.value.length && typeof enableGolfLocationsResult.value[0] == 'function'){
                                    _.each(enableGolfLocationsResult.value, function(func){
                                        golfLocations = func(golfLocations);                                    
                                    })
                                } else {
                                    golfLocations = _.filter(golfLocations, function(golfLocation){
                                        return _.contains(enableGolfLocationsResult.value, golfLocation.LocationId);
                                    });
                                }
                            }                        
                        }
                        if (golfLocations.length == 0) {
                            app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                                title: app.localization.golf.error.noLocationsAccess,
                                message: '' // r_pr.Result ? "(" + r_pr.Result.Text + ")" : ""
                            });
                            app.dispatcher.replace('','',[]);
                            return;
                        }
                        // Dynamic restriction code for enable Golf Locations
                        if (golfLocations.length > 1 && !stop) {
                            app.views.golfView.event.fire('requestGolfLocationSelection', [golfLocations]);
                        } else {
                            var golfLocationId = $.firstOrOnly(golfLocations).LocationId;
                            app.models.golfModel.setSelected('golfLocations', {}, golfLocationId);
                            self.golfLocationSelected(golfLocationId);
                        }
                    } else {
                        app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                            title:app.localization.golf.error.zeroLocations //,
                            //message:"("+r_ss.Result.Text+")",
                        });
                        app.dispatcher.replace('greeting','show',[])
                    }
                })
                .fail(function (r_gl) {
                    app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                        title:app.localization.golf.error.noLocations //,
                        //message:"("+r_ss.Result.Text+")",
                    });
                    app.dispatcher.replace('greeting','show',[])
                });
        },

        golfLocationSelected:function (golfLocationId, golfCourseId, startDate, startTime, endDTime, numberOfPlayers, stop, groupCode, grpTeeTime) {
            var self = this;
            app.models.golfModel.setSelected('golfLocations', {}, golfLocationId);
            $.when(
                app.models.golfModel.getData('golfLocations',{}),
                app.models.golfModel.getData('golfCourses',{'LocationId':golfLocationId})
            )
                .done( function( r_gl, r_gc) {
                    if (r_gc.GolfCourse != undefined) {
                        var golfCourses = r_gc.GolfCourse;
                        // Dynamic restriction code for enable Golf Courses
                        if(app.customization.dynamicRestrictions && app.commonViewHelper.activeEffects.enableGolfCourses){
                            var enableGolfCoursesResult = app.commonViewHelper.groupEffects(app.commonViewHelper.activeEffects.enableGolfCourses);
                            if(enableGolfCoursesResult.isActive && enableGolfCoursesResult.value && enableGolfCoursesResult.value.length){
                                if(typeof enableGolfCoursesResult.value == 'object' && enableGolfCoursesResult.value.length && typeof enableGolfCoursesResult.value[0] == 'function'){
                                    _.each(enableGolfCoursesResult.value, function(func){
                                        golfCourses = func(golfCourses);                                    
                                    })
                                } else {
                                    golfCourses = _.filter(golfCourses, function(golfCourse){
                                        return _.contains(enableGolfCoursesResult.value, golfCourse.CourseId);
                                    });
                                }
                            }                        
                        }
                        if (golfCourses.length == 0) {
                            app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                                title: app.localization.golf.error.noLocationsAccess,
                                message: '' // r_pr.Result ? "(" + r_pr.Result.Text + ")" : ""
                            });
                            app.dispatcher.replace('','',[]);
                            return;
                        }
                        // Dynamic restriction code for enable Golf Courses

                        if (golfCourses.length>1) {
                            if (_.any(golfCourses,function(x){return x.CourseId==golfCourseId}) && !stop) {
                                self.golfCourseSelected(golfCourseId, startDate, startTime, endDTime, numberOfPlayers, false, groupCode, grpTeeTime);
                            } else{
                                app.views.golfView.event.fire('requestGolfCourseSelection',[r_gl.GolfLocation, golfCourses]);
                            }
                        } else {
                            var onlyGolfCourseId = $.firstOrOnly(golfCourses).CourseId;
                            app.models.golfModel.setSelected('golfCourses',{'LocationId':golfLocationId},onlyGolfCourseId);
                            self.golfCourseSelected(onlyGolfCourseId, startDate, startTime, endDTime, numberOfPlayers, false, groupCode, grpTeeTime);
                        }
                    }
                    else {
                        app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                            title:app.localization.golf.error.zeroCourses //,
                            //message:"("+r_ss.Result.Text+")",
                        });
                        if (r_gl.GolfLocation.length==1)
                            app.dispatcher.replace('greeting','',[])
                        else
                            app.dispatcher.replace('golfBooking','',['1'])
                        // app.views.golfView.event.fire('requestGolfLocationSelection');
                    }
                })
                .fail( function( r_gl, r_gc) {
                    app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                        title:app.localization.golf.error.noCourses //,
                        //message:"("+r_ss.Result.Text+")",
                    });
                    if (!r_gl.GolfLocation || r_gl.GolfLocation.length==1) {
                        app.dispatcher.replace('greeting','',[]) }
                    else
                        app.dispatcher.replace('golfBooking','',['1'])
                });
        },

        golfCourseSelected : function ( golfCourseId, startDate, startTime, endDTime, numberOfPlayers, stop, groupCode, grpTeeTime) {
            $.when(
                ( !app.models.golfModel.dataModel.golfLocations.data
                    ? app.models.golfModel.getData('golfLocations', {})
                    : app.models.golfModel.dataModel.golfLocations.data[
                        app.models.golfModel.makeStandardName(app.models.golfModel.dataModel.golfLocations, {})
                    ]
                ),
                app.models.systemModel.validatePMSBeforeSpa()
            ).then(function(golfLocations){
                var propertyId;
                golfLocations.GolfLocation.some(function(loc){
                    if(loc.LocationId == app.models.golfModel.getSelectedValue('golfLocations')) {
                        propertyId = loc.PropertyId;
                        return true;
                    }
                    return false;
                })
                if ((app.customization.golfBooking.PMSRoomMandatory || []).indexOf(golfCourseId) >= 0) {
                    var pmsExists = startDate === undefined ? true : 
                        ((app.data.pmsDateList || {})[propertyId] || []).some(function(dateObj){
                            return dateObj.machine == startDate;
                        });
                    
                    !pmsExists && app.data.messages.push({
                        type:'alert', 'class':'alert-info alert-no-autoclose', actions:[],
                        title:app.localization.golf.pmsbeforeGolf.notice
                    });
                }

                $.when (
                    app.models.golfModel.getData('golfLocations',{}),
                    app.models.golfModel.getData('golfCourses',{'LocationId':app.models.golfModel.getSelectedValue('golfLocations')})
                )
                    .done( function(r_gl, r_gc) {
                        app.models.golfModel.setSelected('golfCourses', {'LocationId':app.models.golfModel.getSelectedValue('golfLocations')}, golfCourseId);
                        if (startDate && ((startTime && endDTime && numberOfPlayers) || app.customization.golfBooking.showTeeSheet) /*&& !stop*/) {
                            app.dispatcher.dispatch('golfBooking', 'teetime', [startDate, startTime, endDTime, numberOfPlayers, groupCode, grpTeeTime]);
                        } else {
                            app.views.golfView.event.fire('requestGolfTeeInfo', [r_gc.GolfCourse, app.models.golfModel.getSelectedItem('golfLocations',{}), startDate, startTime, endDTime, numberOfPlayers, groupCode]);
                        }
                    })
                    .fail( function( r_gc) {
                        app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                            title:app.localization.golf.error.noCourses //,
                            //message:"("+r_ss.Result.Text+")",
                        });
                        app.dispatcher.replace('golfBooking','location',[app.models.golfModel.getSelectedValue('golfLocations'),'','','','','','1'])
                    });
                })
            //app.data.selectedGolfCourse = golfCourseId;

        },

        golfTeeTimeSelected : function (startDate, startTime, endDTime, numberOfPlayers, groupCode, grpTeeTime, showGolferInfoModal, locationId, courseId, selectedTeeDateTime, maxPlayerSlots, displayTime) {
            //This part is only for golf member roster becuase we need the location info whne it's cleared out
            if(!app.data.userLoggedIn){
                //for anonymous user, we need to book
                 //we're skipping the modal logic when the user is not logged in because we ha different logic for that
                showGolferInfoModal = false;
            }

            if(!app.models.golfModel.getSelectedItem('golfLocations',{}) && showGolferInfoModal && app.customization.golfBooking.enableGolfMemberRoster){
                $.when (
                    app.models.golfModel.getData('golfLocations',{}),
                    app.models.golfModel.getData('golfCourses',{'LocationId':locationId})
                )
                    .done( function(r_gl, r_gc) {
                        app.models.golfModel.setSelected('golfLocations', {}, locationId);
                        app.models.golfModel.setSelected('golfCourses', {'LocationId':locationId}, courseId);
                        if (startDate && ((startTime && endDTime && numberOfPlayers) || app.customization.golfBooking.showTeeSheet)) {
                            app.dispatcher.dispatch('golfBooking', 'teetime', [startDate, startTime, endDTime, numberOfPlayers, groupCode, grpTeeTime, showGolferInfoModal, locationId, courseId, selectedTeeDateTime, maxPlayerSlots]);
                        } else {
                            app.views.golfView.event.fire('requestGolfTeeInfo', [r_gc.GolfCourse, app.models.golfModel.getSelectedItem('golfLocations',{}), startDate, startTime, endDTime, numberOfPlayers, groupCode]);
                        }
                    })
                    .fail( function( r_gc) {
                        app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                            title:app.localization.golf.error.noCourses //,
                            //message:"("+r_ss.Result.Text+")",
                        });
                        app.dispatcher.replace('golfBooking','location',[app.models.golfModel.getSelectedValue('golfLocations'),'','','','','','1'])
                    });
                    return;
            }
            var golfloc = app.models.golfModel.getSelectedItem('golfLocations', {})
            var startDateTime = startDate + startTime;
            var endDateTime = startDate + endDTime;
            var golfTeeParameters = {
                'Players':numberOfPlayers,
                'StartDateTime':startDateTime,
                'EndDateTime':endDateTime,
                'Version':'2',
                Date: startDate,
                GroupCode: groupCode
            };
            if (app.data.userLoggedIn) {
                golfTeeParameters.CustomerId = app.data.CustomerId
                golfTeeParameters.CustomerGUID = app.data.CustomerGUID
            }
            if (groupCode) { golfTeeParameters.GroupCode = groupCode }
            if (app.customization.golfBooking.showTeeSheet) {
                $('#progressIndicator').modal('show');
                // we need this for previously booked slots and other information
                app.datal('golfTeeSheetArgs', Array.prototype.slice.call(arguments));
                app.models.golfModel.getData('golfTeeSheet', golfTeeParameters)
                .done( function(r_gt) {
                    $('#progressIndicator').modal('hide');
                    // Dynamic Access Restriction Golf Tee Time Apart Rule group back to back tee times together
                    var groupedBookedTeeTimesArr = [];
                    var tempBookedTeeTimesArr = [];
                    var tempTeeTimeDate = '';
                    var playerOverLimit = r_gt.PlayerOverLimit && r_gt.PlayerOverLimit === 'Y';

                    if(playerOverLimit){
                        app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                            title:app.localization.golf.playerOverLimit,
                        });
                    }

                    if(!app.data.groupedBookedGolfTeeTimes){
                        app.data.groupedBookedGolfTeeTimes = [];
                    }
                    if  (r_gt.TeeReservations && r_gt.TeeReservations.Reservation) {
                        r_gt.TeeReservations.Reservation = $.wrapArray(r_gt.TeeReservations.Reservation)
                    }
                    if  (r_gt.TeeTimes && r_gt.TeeTimes.TeeTime) {
                        r_gt.TeeTimes.TeeTime = $.wrapArray(r_gt.TeeTimes.TeeTime)
                        r_gt.TeeTimes.TeeTime = _.filter(r_gt.TeeTimes.TeeTime, function(teeTime){
                            teeTime.canBook = true;
                            if  (   teeTime.Reservation
                                    && _.any(
                                        $.wrapArray(teeTime.Reservation),
                                        function(teeReservation){
                                            if (teeReservation.StartTime==teeTime.DateTime) {
                                                teeTime.reservationStart = true;
                                                if (teeReservation.CanBook!='Y'){
                                                    teeTime.reservationStartUserHasNoAccess = true;
                                                }
                                            }
                                            if (teeReservation.CanBook!='Y'){
                                                teeTime.canBook = false;
                                                return true
                                            } else {
                                                return false
                                            }
                                        }
                                    )
                                ) {
                                    teeTime.slotsAvailable = "0"
                                } else if (teeTime.TimeLocked == "Y") {
                                    teeTime.slotsAvailable = "0";
                                } else {
                                    teeTime.slotsAvailable = teeTime.SlotsAvailable;
                                }
                            if ( teeTime.Rates && teeTime.Rates.Rate && !$.isArray(teeTime.Rates.Rate)) {
                                    teeTime.oneRate = true;
                                    teeTime.Rates.Rate = $.wrapArray(teeTime.Rates.Rate)
                            } else {
                                    teeTime.multiRate = true;
                            }
                           
                            if (golfloc.ShowEmptyTeeOnly == 'Y' && teeTime.slotsAvailable != "4") {
                            // if (app.customization.golfBooking.onlyShowTeeTimesWithFourAvailableSlots && teeTime.slotsAvailable != "4") {
                                teeTime.slotsAvailable = "0"
                            }
                            if (teeTime.P1FirstName=="PRIVATE" && teeTime.P1LastName=="MEMBER") {
                                teeTime.P1Private = true;
                            }
                            if (teeTime.P2FirstName=="PRIVATE" && teeTime.P2LastName=="MEMBER") {
                                teeTime.P2Private = true;
                            }
                            if (teeTime.P3FirstName=="PRIVATE" && teeTime.P3LastName=="MEMBER") {
                                teeTime.P3Private = true;
                            }
                            if (teeTime.P4FirstName=="PRIVATE" && teeTime.P4LastName=="MEMBER") {
                                teeTime.P4Private = true;
                            }

                            var objExtend = _.extend(location, _.extend(app.models.golfModel.getSelectedItem('golfLocations', {}), app.models.golfModel.getSelectedItem('golfCourses', {'LocationId':app.models.golfModel.getSelectedValue('golfLocations')})));
                            var bookingWindow = app.commonViewHelper.getBookingWindow('Golf', objExtend)
                            var teeTimeConvert = moment.tz(teeTime.DateTime, 'YYYY-MM-DDHHmmss', bookingWindow.timeZone);
                            var now = moment.tz(bookingWindow.timeZone);

                            var endMinTime = teeTimeConvert.clone()
                            if (!_.isEmpty(bookingWindow.endOffset)) {
                                endMinTime.add(bookingWindow.endOffset)
                            }
                            if (!_.isEmpty(bookingWindow.endSet)) {
                                _.each(bookingWindow.endSet, function(num, unit) {
                                    endMinTime[unit](num)
                                })
                            }

                            var startMaxTime = moment('2000-01-01')
                            if (!_.isEmpty(bookingWindow.startOffset)) {
                                startMaxTime = teeTimeConvert.clone()
                                startMaxTime.add(bookingWindow.startOffset)
                            }
                            if (!_.isEmpty(bookingWindow.startSet)) {
                                _.each(bookingWindow.startSet, function(num, unit) {
                                    startMaxTime[unit](num)
                                })
                            }
                            return ( endMinTime > now && now >= startMaxTime ) && teeTime
                        })
                        if(app.customization.dynamicRestrictions){
                            // Dynamic Access Restriction Golf Tee Time Apart Rule group back to back tee times together
                            tempTeeTimeDate = r_gt.TeeTimes && r_gt.TeeTimes.TeeTime.length && r_gt.TeeTimes.TeeTime[0].DateTime ? r_gt.TeeTimes.TeeTime[0].DateTime.substr(0,10) : '';
                            _.forEach(r_gt.TeeTimes.TeeTime, function(teeTime){
                                if(parseInt(teeTime.SlotsAvailable) < 4 || teeTime.Reservation){
                                    tempBookedTeeTimesArr.push(teeTime.Time);
                                } else if(tempBookedTeeTimesArr.length){
                                    groupedBookedTeeTimesArr.push(tempBookedTeeTimesArr);
                                    tempBookedTeeTimesArr = [];
                                }
                            })
                            var groupBookedTeeTimesObj = {};
                            if(groupedBookedTeeTimesArr.length){
                                groupBookedTeeTimesObj[tempTeeTimeDate] = groupedBookedTeeTimesArr;
                            }
                            app.data.groupedBookedGolfTeeTimes = _.filter(app.data.groupedBookedGolfTeeTimes, function(groupTeetimes){
                                return !groupTeetimes[tempTeeTimeDate];
                            })
                            app.data.groupedBookedGolfTeeTimes.push(groupBookedTeeTimesObj);
                        }
                    }

                    // We're saving tee times to get the player positions and player names for already booked tee times
                    app.datal('teeTimes', r_gt.TeeTimes);
                    
                    if ( r_gt.TeeTimes
                        && r_gt.TeeTimes.TeeTime
                        && _.any(r_gt.TeeTimes.TeeTime, function(teeTime){ return teeTime.slotsAvailable > 0 }) ) {
                            // if slots are available
                            r_gt.TeeTimes.CourseId = app.models.golfModel.getSelectedValue('golfCourses') //set course ID
                            app.views.golfView.event.fire('requestTeeTimeSelection',[r_gt.TeeTimes, numberOfPlayers, startDate, startTime, endDTime, groupCode, playerOverLimit]);
                    } else {
                        app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                            title:app.localization.golf.error.zeroTeeTime /*,
                            message:"(Zero tee times returned)"*/
                        });
                        app.views.golfView.event.fire('requestTeeTimeSelection',[r_gt.TeeTimes, numberOfPlayers, startDate, startTime, endDTime, groupCode, playerOverLimit]);
                    }
                    //if invalid group code throw error prompt
                    if(groupCode){
                        var isTeeTimeUnlocked = r_gt.TeeTimes && r_gt.TeeTimes.TeeTime ? _.find(r_gt.TeeTimes.TeeTime, function(teeTime){ return teeTime.Reservation && (teeTime.DateTime == grpTeeTime && (teeTime.Reservation.GroupCodeValid && teeTime.Reservation.GroupCodeValid === 'Y'))}) : false;
                        if(!isTeeTimeUnlocked){
                            if(!$('button[id="'+grpTeeTime+'"]').parent().find('.alert-error').length){
                                $('button[id="'+grpTeeTime+'"]').parent().append('<p class="alert alert-error">'+ app.localization.golf.courseReservedErr +'</p>')
                            }
                        }
                    }

                    if(showGolferInfoModal && app.customization.golfBooking.enableGolfMemberRoster){
                        if(app.data.userLoggedIn){
                            $('#progressIndicator').modal('show');
                            app.commonViewHelper.saveGrpMembersAndDirectoryInfo(function(groupMembers, clubDirectory){
                                var selectedCourse = app.models.golfModel.getSelectedItem('golfCourses', {'LocationId':app.models.golfModel.getSelectedValue('golfLocations')})
                                var normalizedGrpMembers = groupMembers && groupMembers.GroupMember ? groupMembers.GroupMember : [];
                                
                                var allowSamePlayerBooking = selectedCourse && selectedCourse.RestrictSamePlayer && selectedCourse.RestrictSamePlayer === 'N';

                                function customerHasTeeTimeBookedForCourse(dateTime, customerId, courseId){
                                    return _.find(app.data.golfBookings || [], function(booking){
                                        return booking.BookingTime=== dateTime && booking.CourseId === courseId && _.find($.wrapArray(booking.GolfPlayer), function(player){
                                            return player.CustomerId === customerId || player.MemberBookingId === customerId;
                                        });
                                    });
                                }
                                function hasTeeTimeInCart(dateTime, courseId, customerId){
                                    var cartData = app.data.cartData
                                    if(cartData && cartData.rawData && cartData.rawData.WebFolioItem){
                                        var webFolioItems = $.wrapArray(cartData.rawData.WebFolioItem)
                                        return _.find(webFolioItems || [], function(booking){ 
                                            return booking.DisplayStartTime === dateTime && booking.CourseId === courseId && booking.CustomerId === customerId;
                                         });
                                    } else {
                                        return null;
                                    }
                                }
                              

                                var filteredClubDirWithSameplayerCheck = allowSamePlayerBooking ? clubDirectory : _.filter(clubDirectory, function (member) {
                                    return !customerHasTeeTimeBookedForCourse(selectedTeeDateTime, member.MemberBookingId, golfloc.CourseId) && !hasTeeTimeInCart(selectedTeeDateTime, golfloc.CourseId, member.MemberBookingId);
                                });

                                var filteredGrpMembersWithSamePlayerCheck = allowSamePlayerBooking ? normalizedGrpMembers : _.filter(normalizedGrpMembers, function (member) {
                                    return !customerHasTeeTimeBookedForCourse(selectedTeeDateTime, member.CustomerId, golfloc.CourseId) && !hasTeeTimeInCart(selectedTeeDateTime, golfloc.CourseId, member.CustomerId);
                                });
                                $('#progressIndicator').modal('hide');
                                app.views.golfView.event.fire('showGolferInformationModal',[golfloc.CourseId, selectedTeeDateTime, maxPlayerSlots, '', '', '', '', golfloc.LocationId, filteredGrpMembersWithSamePlayerCheck, filteredClubDirWithSameplayerCheck, displayTime]);
                           });
                        } else {
                            app.views.golfView.event.fire('showGolferInformationModal',[golfloc.CourseId, selectedTeeDateTime, maxPlayerSlots, '', '', '', '', golfloc.LocationId, '', '', displayTime]);
                        }
                        
                    }

                })
                .fail( function( r_gt) {
                    $('#progressIndicator').modal('hide');
                    app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                        title:Localization.golf.error.noTeeTime /*,
                        message:"(Request to server failed)"*/
                    });
                    app.views.golfView.event.fire('requestTeeTimeSelection',[ [], numberOfPlayers, startDate, startTime, endDTime, groupCode, false]);
                });
            } else {
                app.commonViewHelper.fetchFilteredGolfTeeSheet(golfTeeParameters, true)
                .done( function(r_gt) {
                    var teeTimeArr = JSON.parse(JSON.stringify((r_gt.TeeTimes || {}).TeeTime || []));
                    var playerOverLimit = r_gt.PlayerOverLimit && r_gt.PlayerOverLimit === 'Y';
                    var golfTeeTimesIndex = _.findIndex(teeTimeArr, function(tt){
                        return tt.DateTime == startDate + startTime;
                    });
                    teeTimeArr = teeTimeArr.filter(function(tt){
                        return tt.SlotsAvailable >= golfTeeParameters.Players && (!tt.Reservation || tt.Reservation.CanBook == "Y") && tt.TimeLocked !== 'Y';
                    });
                    var teeTimeArrLength = teeTimeArr.length-1;
                    golfTeeTimesIndex = golfTeeTimesIndex > teeTimeArrLength ? teeTimeArrLength : golfTeeTimesIndex;
                    var timesToShowCount = app.customization.golfBooking.teeTimeSlotsBeforeUserSelectTime + app.customization.golfBooking.teeTimeSlotsAfterUserSelectTime+1;
                    var indexToStart = golfTeeTimesIndex - app.customization.golfBooking.teeTimeSlotsBeforeUserSelectTime;
                    if(indexToStart < 0) {
                        timesToShowCount += indexToStart;  
                        indexToStart = 0;
                    }
                    var indexToEnd = indexToStart + timesToShowCount;
                    var golfTeeTimes = teeTimeArr.slice(indexToStart, indexToEnd);
                    golfTeeTimes.forEach(function(tt){
                        tt.Rates = [].concat(tt.Rates.Rate);
                    })
                    var golfloc = app.models.golfModel.getSelectedItem('golfLocations',{});

                    if(playerOverLimit){
                        app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                            title:app.localization.golf.playerOverLimit,
                        });
                    }

                    if (golfloc.ShowEmptyTeeOnly == 'Y' && golfTeeTimes && golfTeeTimes.length) {
                        golfTeeTimes = _.filter(golfTeeTimes,function(v){

                            return v.SlotsAvailable == 4
                        })
                        if (golfTeeTimes.length<1) {
                            golfTeeTimes = undefined;
                        }
                    }
                    if (golfTeeTimes != undefined) {
                        var golfTeeInfo = {TeeTime: golfTeeTimes};
                        golfTeeInfo.CourseId = app.models.golfModel.getSelectedValue('golfCourses');
                        app.views.golfView.event.fire('requestTeeTimeSelection',[golfTeeInfo, numberOfPlayers, startDate, startTime, endDTime, groupCode, playerOverLimit]);
                    } else {
                        app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                            title:app.localization.golf.error.zeroTeeTime /*,
                            message:"(Zero tee times returned)"*/
                        });
                        app.dispatcher.replace('golfBooking','course',[app.models.golfModel.getSelectedValue('golfCourses'),'','','','','1'])
                    }
                })
                .fail( function( r_gt) {
                    app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                        title:Localization.golf.error.noTeeTime /*,
                        message:"(Request to server failed)"*/
                    });
                    app.dispatcher.replace('golfBooking','course',[app.models.golfModel.getSelectedValue('golfCourses'),'','','','','1'])
                });
            }
        },
        showGolferInfoModal: function(courseId, dateTime, maxSlots, rateId, groupCode, price, golfRates, displayTime) {
            //regular golfer info modal
            var enableGolferNamesModal = app.customization.golfBooking.enableGolferNamesModal;
            var enableGolferMemberRoster = app.customization.golfBooking.enableGolfMemberRoster;
            var isLoggedIn = app.data.userLoggedIn;
            
            if(enableGolferNamesModal || (enableGolferMemberRoster && !isLoggedIn)){
                app.views.golfView.event.fire('showGolferInformationModal',[courseId, dateTime, maxSlots, rateId, groupCode, price, golfRates, '', '', '',displayTime]);
            } else if (enableGolferMemberRoster && enableGolferNamesModal) {
                app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                        title:app.localization.golf.modal.errorBothFlagsEnabled
                    });
            }
        },
        golfRates : function (courseId, dateTime, numberOfPlayers, rateId, groupCode, price, guestNotes) {
            var self = this;
            if (!courseId || !dateTime || !numberOfPlayers) {
                app.dispatcher.replace('golfBooking','course',[app.models.golfModel.getSelectedValue('golfCourses')]);
                return;
            };
            if (! (locationId = app.models.golfModel.getSelectedValue('golfLocations'))) {
                app.dispatcher.replace('golfBooking','',[]);
                return;
            };
            var date=dateTime.substr(0,10);
            var time =dateTime.substr(10);
            var golfRateParameters = {
                'CustomerId':app.data.CustomerId || app.data.DefaultCustomerId,
                'CourseId':courseId,
                'Date':date,
                'TeeTime':app.rs.DateToString(dateTime, "hh:mm tt")
            };
            
            $.when (app.models.golfModel.getData('golfRates', golfRateParameters))
                .done( function(r_gr) {
                    self.golfBook(locationId, courseId, rateId, r_gr.Price, date, time, numberOfPlayers, groupCode, guestNotes);
                })
                .fail( function(r_gr) {
                    var message = app.localization.golf.error.noRates;
                    var redir = false;
                    
                    if (r_gr.Result.ErrorId=='1005') {
                        message = app.localization.golf.error.datePast;
                    }
                    if (r_gr.Result.ErrorId=='501') {
                        message = app.localization.golf.error.zeroCourses;
                        redir = ['golfBooking','location',[locationId,'','','','','','1']];
                    }
                    
                    app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                        title:message
                    });
                    
                    if (redir) {
                        app.dispatcher.replace.apply(self,redir);
                    };
                    
                    app.dispatcher.replace('golfBooking','course',[app.models.golfModel.getSelectedValue('golfCourses'),date, time,'235959',numberOfPlayers]);
                });

        },
        golfPartialPayment: function (folioId, folioCustomerId) {
            if (app.data.userLoggedIn) {
                $.when(
                        app.models.userModel.getData('fetchCustomerGolfBookings', {
                            CustomerId: app.data.CustomerId,
                            CustomerGUID: app.data.CustomerGUID,
                            BookStatus: "RESERV"
                        }))
                    .done(function (folios) {
                        var golfFolio = _.find(folios.GolfBooking, function (folio) {
                            return folio.GolfBookingId == folioId
                        })

                        
                        if(golfFolio){
                            golfFolio.itemName = _.find(golfFolio.GolfPlayer,function(player){
                                return player.CustomerId == app.data.CustomerId
                            }).ItemName
                            golfFolio.date =  moment(golfFolio.BookingTime, 'YYYY-MM-DDHHmmss').format('LLL')
                            app.views.golfView.event.fire('requestGolfPartialPayment', [golfFolio, folioId])
                        }
                    })
                    .fail(function (err) {
                        console.log("failed to fetch golf Bookings", err)
                    })
            } else {
                app.data.loginNextURL = ['spaBooking', 'partialPayment', [folioId, folioCustomerId]]
                app.data.messages.push({
                    type: 'alert',
                    'class': 'alert-error',
                    actions: [],
                    title: app.localization.general.postPayment.loginFirst,
                    message: ''
                });
                app.dispatcher.redirect('profile', 'login', ["partial-payment"]);
            }
        },
        golfBook : function ( locationId, courseId, itemId, price, date, time, numberOfPlayers, groupCode, guestNotes) {
            var membershipIds = app.data.membershipDetails && app.data.membershipDetails.membershipItemIds || [];
            var vipLevels = app.data.membershipDetails && app.data.membershipDetails.VIPLevels || [];
            app.commonViewHelper.eval_ttb({module:"golfBooking", locationId:locationId, courseId:courseId, itemId:itemId, price:price, date:date, time:time, numberOfPlayers:numberOfPlayers, groupCode:groupCode, vipLevel: vipLevels, membershipId:membershipIds });

            // Dynamic access rest 
            if(app.commonViewHelper.active_ttb_effects.golfTryingToBookErr) {
                var golfTryingToBookErrRes = app.commonViewHelper.groupEffects(app.commonViewHelper.active_ttb_effects.golfTryingToBookErr);
                if(golfTryingToBookErrRes.isActive){
                    app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                        title:app.localization.golf.error.noBooking,
                        message:golfTryingToBookErrRes.value
                    });
                    app.commonViewHelper.showMessages();
                    $('#progressIndicator').modal('hide');
                    $('.modal-backdrop.fade').remove();
                    return 
                } 
            }
            
            if (!locationId || !courseId || !itemId || !price || !date || !time || !numberOfPlayers) {
                app.dispatcher.replace('golfBooking','course',[app.models.golfModel.getSelectedValue('golfCourses')]);
                return;
            }
            var golfBookParameters = {
                    'CustomerId':app.data.DefaultCustomerId,
                    'CourseId':courseId,
                    'LocationId':locationId,
                    'TeeTime':date+time,
                    'Players': numberOfPlayers,
                    'ItemId': itemId,
                    'Price': price,
                    'GuestNotes': guestNotes || ''
                };
            switch(numberOfPlayers) {
                case "4": golfBookParameters.P4ItemId = itemId;
                case "3": golfBookParameters.P3ItemId = itemId;
                case "2": golfBookParameters.P2ItemId = itemId;
                case "1": golfBookParameters.P1ItemId = itemId;
            }
                if (app.data.userLoggedIn) {
                    golfBookParameters.CustomerGUID = app.data.CustomerGUID
                    golfBookParameters.CustomerId =app.data.CustomerId 
                }
            if (groupCode) {
                golfBookParameters.GroupCode=groupCode
            }
            $('#progressIndicator').modal('show');
            
            $.when ( app.models.golfModel.getData('bookTeeTime', golfBookParameters) )
                .done( function(r_gb) {
                    console.log(r_gb, 'golfbooking tee time after booking');
                    if (r_gb.GolfBookingId != undefined) {
                        app.data.messages.push({ type:'alert', 'class':'alert-success', actions: [],
                            title:app.localization.golf.successfullBookingMessage,
                            message:Localization.spaBooking.confirmation.customerCustomTextFooter
                        });
                        //app.models.systemModel.getData('folioBalance', {}).always(function(){
                        
                            app.commonViewHelper.updatePlaceHolderDate(date);
                            
                            app.dispatcher.replace('summary','show',[]);
                        //});
                    } else {
                        app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                            title:app.localization.golf.error.noBooking,
                            message:(r_gb && r_gb.Result) ? "("+r_gb.Result.Text+")" : ""
                        });
                        app.dispatcher.replace('golfBooking','course',[app.models.golfModel.getSelectedValue('golfCourses'),date,time,'235959',numberOfPlayers,'1',groupCode])
                    }
                    $('#progressIndicator').modal('hide');
                })
                .fail( function( r_gt) {
                    $('#progressIndicator').modal('hide');

                    var message = app.localization.golf.error.noBooking,
                        redir = false
                    try {
                        // Let's show back end error message if any
                        message = r_gt.Result ? r_gt.Result.Text : "";
                        if (r_gt.Result.ErrorId=='512') {
                            message = app.localization.golf.error.slotLocked
                        }
                        if (r_gt.Result.ErrorId=='515') {
                            message = app.localization.golf.error.exceedsLimit
                        }
                    } catch (e) {

                    }
                    app.data.messages.push({ type:'alert', 'class':'alert-error', actions: [],
                        title:message
                    });
                    app.dispatcher.replace('golfBooking','course',[app.models.golfModel.getSelectedValue('golfCourses'),date,time,'235959',numberOfPlayers,'1',groupCode])
                });
        },
    })
});

